import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category/category.service';
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
import { ProductService } from "../services/product/product.service";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  categories=[];
  fournisseurs;
  productByCategory;
  pageSize = 12;
  page;
  total;
  prixMin;
  prixMax;
  contentLoaded = false;
  listF1=[];
  listF2=[];
  listF3=[];
  baseUrl = environment.baseUrl;

  startIndex = 1;
  totalPages = 0;
  itemsPerPage = 12;
  pageNumbers: any;

  constructor(private categoryService:CategoryService,private route: ActivatedRoute,private productService:ProductService,private router: Router) { }

  nextPage() {
    if (this.startIndex < this.totalPages) {
      this.startIndex++;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  previousPage() {
    if (this.startIndex > 1) {
      this.startIndex--;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  goToPage(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.startIndex = pageNumber;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['page']) {
        this.startIndex = params['page']
      }
    })
    this.loadData();
  }

  getPageNumbersArray() {
    for (let i = this.startIndex; i < this.startIndex + 5 && i <= this.totalPages; i++) {
      this.pageNumbers.push(i);
      console.log('this.pageNumbers', this.pageNumbers);
      
    }
    if (this.startIndex + 5 < this.totalPages) {
      this.pageNumbers.push('...');
      this.pageNumbers.push(this.totalPages);
    }
    return this.pageNumbers;
  }

  loadData() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      var q = params.get('q')
      this.productService.searchByKeyWord(q, this.startIndex).subscribe(res => {
         this.productByCategory = res['produits'];
         this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
          if (this.totalPages > 10) {
            if (
              Number(this.startIndex) <= this.totalPages - 5 &&  Number(this.startIndex) > this.totalPages - 5 || 
              Number(this.startIndex) <= this.totalPages - 4 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 3 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 2 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 1 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages &&  Number(this.startIndex) > this.totalPages - 5
              ) {
              this.pageNumbers = [
                1, 2 , '...', this.totalPages - 4,  this.totalPages - 3,  this.totalPages - 2,  this.totalPages - 1,  this.totalPages
              ];
            } else {
              if (Number(this.startIndex) > 2) {
                this.pageNumbers = [
                  1, 2 , '...', this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
                ];
              } else {
                this.pageNumbers = [
                  this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
                ];
              }
            }
          } else {
            this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
          }
         
         this.fournisseurs      = res['fournisseurs'][0];
         this.total = this.productByCategory.length;
         this.contentLoaded = true;
       });
    })
  }

  changeMax(nbrProducts)
  {
    this.pageSize = nbrProducts;
  }

  filtrePrix()
  {

  }



}
